import React, { useState } from 'react';

import { useQuery, useMutation } from '@tanstack/react-query';

import Select from '../../../../../Form/Select';
import Button from '../../../../../Button';

import LoanService from '../../../../../../services/LoanService';
import { formatCurrency } from '../../../../../../helpers/currencyMask';
import { useUiContext } from '../../../../../../context/UiContext';
import ClaimService from '../../../../../../services/ClaimService';

export default function AddBillForm({ loanId, claim, refetchClaim }) {
  const [currentBill, setCurrentBill] = useState('');

  const { showToast } = useUiContext();

  const {
    data: bills,
    refetch,
    isFetching,
  } = useQuery({
    queryKey: ['loanBillsForClaim', loanId],
    queryFn: () =>
      LoanService.getLoanBills({
        loanId,
        unassociatedWithClaim: true,
        type: 'Claim Distribution',
      }),
    enabled: !!loanId,
  });

  const { mutate: updateClaim, isPending } = useMutation({
    mutationFn: () => {
      let billIds =
        claim.bill_id?.filter((bill) => !!bill).map((bill) => bill.id) || [];
      billIds = [...billIds, currentBill];

      return ClaimService.updateClaim({
        claimId: claim.id,
        formValues: {
          ...claim,
          bill_id: billIds,
        },
      });
    },
    onSuccess: () => {
      showToast({
        text: 'Bill added to claim',
        type: 'success',
      });
      refetch();
      refetchClaim();
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const selectOptions =
    bills?.map?.((bill) => {
      const label = `${bill.pixel_bill_number} - $${formatCurrency(
        bill?._amount?.total || 0
      )}`;

      return {
        value: bill.id,
        label,
      };
    }) || [];

  return (
    <div>
      <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold flex justify-between w-full mb-6">
        Add bill to claim
      </h2>
      <div className="grid gap-5 md:grid-cols-3 xl:grid-cols-4 flex-grow flex-1 mb-8">
        <Select
          label="Bill"
          options={selectOptions}
          placeholder="Select"
          value={currentBill}
          setFieldValue={(_, value) => {
            setCurrentBill(value);
          }}
        />
      </div>
      <Button
        isSubmitting={isFetching || isPending}
        disabled={!currentBill}
        onClick={updateClaim}
      >
        Add
      </Button>
    </div>
  );
}
